export default __webpack_public_path__ + "static/media/Gifter.c96ba008.png";